module.exports = __webpack_public_path__ + "media/img/mox-5f3c6dd65cce5c67434fd0febc7cda87.png";